export const findCompanyNameById = (companies, companyId) =>
	companies.find((company) => company._id === companyId)?.name || '';
